import * as R from 'ramda';
import { updateFieldValue } from './utils';

import {
    SUBMIT_GET_FORM,
    SUBMIT_GET_FIELD_INSERT_DETAILS,
    SUBMIT_SET_FORM_FIELDS,
    SUBMIT_UPDATE_FORM_FIELD_VALUE,
    SUBMIT_SEND_FORM_SUBMISSION,
    SUBMIT_SET_START_DATE,
    SUBMIT_SET_ERROR
} from './constants';

const defaultState = {
    form: null,
    fields: null,
    startDate: null,
    fieldInserts: [],
    error: {}
};

const formSubmit = (state = defaultState, { type, payload }) => {
    switch (type) {
        case SUBMIT_GET_FORM:
            return R.merge(state, { form: payload });
        case SUBMIT_SET_START_DATE:
            return R.merge(state, { startDate: payload });
        case SUBMIT_SET_FORM_FIELDS:
            return R.merge(state, { fields: payload });
        case SUBMIT_SEND_FORM_SUBMISSION:
            return R.merge(state, { form: payload });
        case SUBMIT_UPDATE_FORM_FIELD_VALUE:
            const fields = updateFieldValue(payload, state.fields);
            return R.merge(state, { fields });
        case SUBMIT_GET_FIELD_INSERT_DETAILS:
            return R.merge(state, { fieldInserts: payload });
        case SUBMIT_SET_ERROR:
            return R.merge(state, { error: payload });    
        default:
            return state;
    }
};

export default formSubmit;
